import { render } from "./Delivery.vue?vue&type=template&id=cbd7a03a"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
script.render = render

export default script